import React from 'react';

function ParrotLoader({ title }) {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center full-height text-center ">
      <img
        src="https://sample-es.parrotfy.com/assets/loader-parrotfy.gif"
        alt="Cargando"
        style={{ width: '250px', height: '250px' }}
      />

      <p style={{ fontSize: '1.3rem', fontWeight: 600, marginTop: '1.5rem' }}>{title}</p>
    </div>
  );
}

export default ParrotLoader;
